import { render } from "./qna.vue?vue&type=template&id=1a7fae0f&scoped=true"
import script from "./qna.vue?vue&type=script&lang=js"
export * from "./qna.vue?vue&type=script&lang=js"

import "./qna.vue?vue&type=style&index=0&id=1a7fae0f&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./qna.vue?vue&type=style&index=2&id=1a7fae0f&scoped=true&lang=css"
import "./qna.vue?vue&type=style&index=3&id=1a7fae0f&scoped=true&lang=css"
import "@/styles/mobile.css?vue&type=style&index=4&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7fae0f"]])

export default __exports__